import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CorporateAppointmentDashboardRoutingModule } from './corporate-appointment-dashboard-routing.module';
import { CorporateAppointmentDashboardComponent } from './corporate-appointment-dashboard.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [CorporateAppointmentDashboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    CorporateAppointmentDashboardRoutingModule
  ]
})
export class CorporateAppointmentDashboardModule { }
